import { createdATFilter } from 'modules/common/constants';

export const paymentSettingsFilters = [createdATFilter];
